/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

// initial state
const state = {
  partner: {
    name: '',
    product: '',
    activity: '',
  },
  affiliation: 'assurup dashboard',
  dataLayer: {},
  hj: () => {},
};

// getters
const getters = {
};

// actions
const actions = {
  /**
   ** Push a checkout with GTM
   * for E-commerce analysis
   * @param {Object}
   * @param {step: String} current step
   * @param {option: String} meta data
   */
  checkout() {
    // DEPRECATED
  },
  /**
   ** Add a product to cart
   * for e-commerce analysis
   * @param {Object} product to be pushed
   */
  addProduct() {
    // DEPRECATED
  },
  /**
   ** Remove product from cart
   * for e-commerce analysis
   * @param {Object} subscription to be removed
   */
  removeProduct() {
    // DEPRECATED
  },
  /**
   ** Send purchase event
   * for e-commer analysis
   */
  purchase() {
    // DEPRECATED
  },
  /**
   **Initialise GTM datalayer
   * mandatory
   * @param {Array} dataLayer
   */
  setDataLayer({ commit }, dataLayer) {
    commit('dataLayer', dataLayer);
  },
  /**
   ** Initialise Hotjar
   * @param {Object} hotjar
   */
  setHotjar({ commit }, hotjar) {
    commit('hotjar', hotjar);
  },
  setAffiliation({ commit }, affiliation) {
    commit('SET_VALUE', { affiliation });
  },
};

// mutations
const mutations = {
  dataLayer(state, dataLayer) {
    state.dataLayer = dataLayer;
  },
  hotjar(state, hj) {
    state.hj = hj;
  },
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key] || null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
